import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-631396cc")

_pushScopeId("data-v-631396cc")
const _hoisted_1 = { class: "late-early-register-container text-black mb-24" }
const _hoisted_2 = { class: "mb-5 content-title" }
const _hoisted_3 = { class: "mb-2 font-bold text-black" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "divide-blue mb-6" }, null, -1)
const _hoisted_5 = { class: "mb-6 ml-3" }
const _hoisted_6 = { class: "mb-2 font-bold text-black" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "divide-blue mb-3" }, null, -1)
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = { class: "mb-2 font-bold text-black" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "divide-blue mb-3" }, null, -1)
const _hoisted_11 = { class: "mb-6 flex justify-between" }
const _hoisted_12 = { class: "font-bold flex text-right" }
const _hoisted_13 = { class: "w-2/3" }
const _hoisted_14 = { class: "w-1/3 font-normal" }
const _hoisted_15 = { class: "font-bold flex text-right" }
const _hoisted_16 = { class: "w-2/3" }
const _hoisted_17 = { class: "w-1/3 font-normal" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "font-bold flex text-right" }
const _hoisted_20 = { class: "w-2/3" }
const _hoisted_21 = { class: "w-1/3 font-normal" }
const _hoisted_22 = { class: "font-bold flex text-right" }
const _hoisted_23 = { class: "w-2/3" }
const _hoisted_24 = { class: "w-1/3 font-normal" }
const _hoisted_25 = { class: "text-red font-bold flex text-right" }
const _hoisted_26 = { class: "w-2/3" }
const _hoisted_27 = { class: "w-1/3 font-normal" }
const _hoisted_28 = { class: "text-red font-bold flex text-right" }
const _hoisted_29 = { class: "w-2/3" }
const _hoisted_30 = { class: "w-1/3 font-normal" }
const _hoisted_31 = { class: "self-end" }
const _hoisted_32 = { class: "font-bold" }
const _hoisted_33 = { class: "mb-2 font-bold text-black" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "divide-blue mb-3" }, null, -1)
const _hoisted_35 = { class: "mb-3" }
const _hoisted_36 = { class: "mb-2 font-bold text-black" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "divide-blue mb-3" }, null, -1)
const _hoisted_38 = { class: "mb-3" }
const _hoisted_39 = { class: "mb-2 font-bold text-black" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "divide-blue mb-3" }, null, -1)
const _hoisted_41 = { class: "mb-6" }
const _hoisted_42 = { class: "btn-upload" }
const _hoisted_43 = { class: "mb-3 flex justify-center" }
const _hoisted_44 = { class: "btn-register" }
const _hoisted_45 = { class: "flex justify-center cursor-pointer btn-cancel" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RadioGroup = _resolveComponent("RadioGroup")
  const _component_InputArea = _resolveComponent("InputArea")
  const _component_InputFile = _resolveComponent("InputFile")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('lateEarlyApplication')), 1),
    _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('targetDate')), 1),
    _hoisted_4,
    _createVNode("div", _hoisted_5, _toDisplayString(_ctx.date), 1),
    _createVNode("div", _hoisted_6, _toDisplayString(_ctx.t('scheduledToWork')), 1),
    _hoisted_7,
    _createVNode("div", _hoisted_8, _toDisplayString(_ctx.data.pattern), 1),
    _createVNode("div", _hoisted_9, _toDisplayString(_ctx.t('stampingRecord')), 1),
    _hoisted_10,
    _createVNode("div", _hoisted_11, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, _toDisplayString(_ctx.t('checkin')) + " :", 1),
          _createVNode("span", _hoisted_14, _toDisplayString(_ctx.data.checkin), 1)
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.t('breakStartTimeRounding')) + " :", 1),
          _createVNode("span", _hoisted_17, _toDisplayString(_ctx.data.breakStartTimeRounding), 1)
        ])
      ]),
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, _toDisplayString(_ctx.t('checkout')) + " :", 1),
          _createVNode("span", _hoisted_21, _toDisplayString(_ctx.data.checkout), 1)
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, _toDisplayString(_ctx.t('breakEndTimeRounding')) + " :", 1),
          _createVNode("span", _hoisted_24, _toDisplayString(_ctx.data.breakEndTimeRounding), 1)
        ])
      ]),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_25, [
          _createVNode("div", _hoisted_26, _toDisplayString(_ctx.t('late')) + " :", 1),
          _createVNode("span", _hoisted_27, _toDisplayString(_ctx.data.late), 1)
        ]),
        _createVNode("div", _hoisted_28, [
          _createVNode("div", _hoisted_29, _toDisplayString(_ctx.t('early')) + " :", 1),
          _createVNode("span", _hoisted_30, _toDisplayString(_ctx.data.early), 1)
        ])
      ]),
      _createVNode("div", _hoisted_31, [
        _createVNode("div", _hoisted_32, _toDisplayString(_ctx.t('totalWorkingHours')) + " : " + _toDisplayString(_ctx.data.totalWorkingHours), 1)
      ])
    ]),
    _createVNode("div", _hoisted_33, _toDisplayString(_ctx.t('applicationType')), 1),
    _hoisted_34,
    _createVNode("div", _hoisted_35, [
      _createVNode(_component_RadioGroup, { "options-radio": _ctx.applicationTypeOption }, null, 8, ["options-radio"])
    ]),
    _createVNode("div", _hoisted_36, _toDisplayString(_ctx.t('reasonsForBeingLateEarly')), 1),
    _hoisted_37,
    _createVNode("div", _hoisted_38, [
      _createVNode(_component_InputArea, { placeholder: _ctx.enterTheApplicationMessage }, null, 8, ["placeholder"])
    ]),
    _createVNode("div", _hoisted_39, _toDisplayString(_ctx.t('attachment')), 1),
    _hoisted_40,
    _createVNode(_component_InputFile, {
      class: "mb-3",
      modelValue: _ctx.fileUpload,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileUpload = $event)),
      onChange: _ctx.onChangeFileUpload,
      multiple: ""
    }, null, 8, ["modelValue", "onChange"]),
    _createVNode("div", _hoisted_41, [
      _createVNode("button", _hoisted_42, _toDisplayString(_ctx.t('uploadFile')), 1)
    ]),
    _createVNode("div", _hoisted_43, [
      _createVNode("button", _hoisted_44, _toDisplayString(_ctx.t('register')), 1)
    ]),
    _createVNode("div", _hoisted_45, _toDisplayString(_ctx.t('cancel')), 1)
  ]))
})